import React from 'react'
import { Field } from 'redux-form'
import PropTypes from 'prop-types'
import {
  withTranslation, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS
} from 'LiveBoard/hocs'

import './style.css.scss'

const UnknownLead = (props) => {
  return (
    <div className="unknown-lead-container">
      <label className="field-label">{props.getTranslation(TRANSLATION_VALUE_KEYS.yourEmail)}</label>
      <Field
        className={`${props.errors.email ? 'error' : ''}`}
        name="email"
        component="input"
        type="email"
        autoFocus={true}
        placeholder={`* ${props.getTranslation(TRANSLATION_VALUE_KEYS.yourEmailHere)}`} />
    </div>
  )
}

UnknownLead.propTypes = {
  errors: PropTypes.object
}

export default withTranslation(TRANSLATION_KEYS.unknownLead)(UnknownLead)